var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"title":_vm.textToTruncate},domProps:{"textContent":_vm._s(_vm.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }